export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface InvoiceSortFilterType {
  sortOption: SortFilterOption<server.dto.InvoiceSort>
}

export const InvoiceSortOptions: Array<SortFilterOption<server.dto.InvoiceSort>> = [
  {
    value: "documentNumberDesc",
    label: RESX.Invoice.InvoiceNumber,
    enabled: true
  },
  {
    value: "statusAsc",
    label: RESX.Status.resxStatus,
    enabled: true
  },
  {
    value: "currencyAsc",
    label: RESX.Financial.Currency,
    enabled: true
  },
  {
    value: "companyAsc",
    label: RESX.Document.Addressee,
    enabled: true
  },
  {
    value: "sendDateAsc",
    label: RESX.DateTime.SendDate,
    enabled: true
  },
  {
    value: "dueDateDesc",
    label: RESX.DateTime.DueDate,
    enabled: true
  },
  {
    value: "salesDesc",
    label: RESX.Financial.Sales,
    enabled: site.permissions.invoice.canReadSales
  },
  {
    value: "lastModifiedDesc",
    label: RESX.GeneralLabels.LastModified,
    enabled: true
  }
];

export const DefaultInvoiceSortFilter: server.dto.InvoiceSort = "documentNumberDesc";

export const getSortOption = (value: server.dto.InvoiceSort) => {
  return InvoiceSortOptions.find((s) => s.value === value);
};

export const initialInvoiceSortFilter: InvoiceSortFilterType = {
  sortOption: getSortOption(DefaultInvoiceSortFilter)
};
